// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const CarLine: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M5.687 19.116a2.514 2.514 0 0 1-1.851-.764 2.528 2.528 0 0 1-.76-1.852H1.691V5h14.847v3.616h2.307l3.462 4.653V16.5H20.69a2.52 2.52 0 0 1-.764 1.852 2.529 2.529 0 0 1-1.855.764 2.513 2.513 0 0 1-1.852-.764 2.527 2.527 0 0 1-.76-1.852H8.308c0 .73-.255 1.35-.764 1.856-.51.506-1.128.76-1.856.76Zm.004-1c.45 0 .832-.157 1.146-.47.313-.314.47-.696.47-1.146 0-.45-.157-.832-.47-1.145a1.559 1.559 0 0 0-1.146-.47c-.45 0-.831.156-1.145.47-.313.313-.47.695-.47 1.145 0 .45.157.832.47 1.145.314.314.695.47 1.145.47Zm-3-2.616h.647c.142-.441.432-.82.869-1.139a2.46 2.46 0 0 1 1.484-.477c.527 0 1.016.156 1.466.468.45.312.746.694.888 1.148h7.493V6H2.69v9.5Zm15.385 2.616c.45 0 .832-.157 1.145-.47.314-.314.47-.696.47-1.146 0-.45-.156-.832-.47-1.145a1.558 1.558 0 0 0-1.145-.47c-.45 0-.832.156-1.145.47-.314.313-.47.695-.47 1.145 0 .45.156.832.47 1.145.313.314.695.47 1.145.47ZM16.538 13.5h4.711l-2.942-3.884h-1.77V13.5Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const CarLineOffset: IconOffset = {
    vertical: 20, // Store Custom Code
    horizontal: 6,
};

export default React.memo(CarLine);
